/**
 * addEventListener for NodeList.
 *
 * @param {string} event
 * @param {function} callback
 * @returns {NodeList}
 */
NodeList.prototype.addEventListener = function (event, callback) {
    if (this.length) {
        this.forEach(el => {
            el.addEventListener(event, callback);
        });
    }
    return this;
};
